import { useApiPrivateRequest } from "../../../shared/hooks/useApi";
import { ExternalAgent } from "../models/ExternalAgent";

export const useUpdateExternalAgent = () => {
  const {
    data: isUpdated,
    call,
    isLoading,
    isFailed,
  } = useApiPrivateRequest<boolean>((_) => true);

  const updateExternalAgent = async (agent: ExternalAgent) => {
    await call(
      `/admin/externalAgents/${agent.agentName}`,
      "PUT",
      undefined,
      agent,
    );
  };

  return {
    updateExternalAgent,
    isUpdated,
    isLoading,
    isFailed,
  };
};
